<template>
  <v-avatar
    v-bind="avatarProps"
    rounded="2"
  >
    <v-icon
      v-bind="iconProps"
      color="icon-stroke-primary"
    />
  </v-avatar>
</template>

<script setup lang="ts">
defineOptions({
  inheritAttrs: false,
})

const definedProps = defineProps({
  ...useIconProps(),
})

const props = useDefaults(definedProps, 'UIcon')
const {
  getIconProps,
  getAvatarProps,
} = useIcon()

const avatarProps = computed(() => getAvatarProps(props))
const iconProps = computed(() => getIconProps(props))
</script>
